import React, { Component } from 'react'
import { connect } from "react-redux"
import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import store from '../../Redux/store'
import { updateGlobalState, addSessionToCurrentVisitAction } from '../../Redux/actions'
import { Button } from '@material-ui/core';
import moment from 'moment'
import uuid from 'react-uuid';

const styles = (theme) => {
    return ({
        card: {
            // marginBottom: '20px'
        },
        cardTitle: {
            marginLeft: '15px',
            marginTop: '15px',
        },
        cardMedia: {
            display: 'flex',
        },
        cardDetails: {
            display: 'flex',
            flexDirection: 'column',
        },
        cardContent: {
            flex: '1 0 auto',
        },
        cardCover: {
            width: 151,
        },
        infoTable: {
            width: '100%'
        },
        paper: {
            padding: '20px'
        },
        link: {
            cursor: 'pointer'
        }
    })
};

class VisitPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            periods: [],
            current_date_time_start: null,
            current_date_time_end: null,
            current_location_start: null,
            current_location_end: null,
            current_duration: 0,
            current_duration_diff: 0,
            current_units: 0,
            isStarted: false,
            buttonText: 'Start',
            isButtonDisabled: false,
            setIntervalHandler: null
        }
    }

    handleButtonClick = e => {
        // store.dispatch(updateGlobalState({
        //     currentVisit: {},
        //     activePageComponent: 'visit-list',
        // }))
        const debug = true

        this.setState({
            ...this.state,
            isStarted: !this.state.isStarted,
            buttonText: '...',
            isButtonDisabled: true
        }, () => {
            new Promise((resolve, reject) => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(resolve, reject, {
                        timeout: 10000
                    });
                }
            })
                .then(position => {
                    this.process_position(position)
                    this.setState({
                        ...this.state,
                        buttonText: this.state.isStarted ? 'Stop' : 'Start',
                        isButtonDisabled: false
                    })
                })
                .catch(error => {
                    console.info(error);
                    if (error.code === window.GeolocationPositionError.POSITION_UNAVAILABLE || error.code === window.GeolocationPositionError.TIMEOUT) {
                        console.info('No encuentro posiscion');
                    }
                    else if (error.code === window.GeolocationPositionError.PERMISSION_DENIED) {
                        console.info('acceso denegado');
                    }

                    if (debug) {
                        this.setState({
                            ...this.state,
                            buttonText: this.state.isStarted ? 'Stop' : 'Start',
                            isButtonDisabled: false
                        })
                        this.process_position({
                            coords: {
                                longitude: 0,
                                latitude: 0
                            }
                        })
                    }
                    else {
                        this.setState({
                            ...this.state,
                            isStarted: !this.state.isStarted,
                            buttonText: !this.state.isStarted ? 'Stop' : 'Start',
                            isButtonDisabled: false
                        })
                    }
                })
        })
    }

    handleVisitsClick = e => {
        store.dispatch(updateGlobalState({
            activePageComponent: 'visit-list',
            currentVisit: {}
        }))
    }

    process_position = (position) => {

        var now = moment()
        const location = position['coords']['latitude'] + ', ' + position['coords']['longitude']

        if (!this.state.isStarted) {
            clearInterval(this.state.setIntervalHandler);
            const sync_queue = JSON.parse(localStorage.getItem('sync_queue'))
            const new_queue = [{
                id: uuid(),
                action: 'add_visit_session',
                visit_id: this.props.currentVisit.id,
                session: {
                    date_time_start: this.state.current_date_time_start.format('YYYY-MM-DD HH:mm:ss'),
                    date_time_end: now.format('YYYY-MM-DD HH:mm:ss'),
                    location_start: this.state.current_location_start,
                    location_end: location,
                }
            }].concat(sync_queue.queue)
            localStorage.setItem('sync_queue', JSON.stringify({
                lastUpdate: Date.now(),
                queue: new_queue
            }))
            store.dispatch(addSessionToCurrentVisitAction({
                date_start: this.state.current_date_time_start.format('YYYY-MM-DD HH:mm:ss'),
                date_end: now.format('YYYY-MM-DD HH:mm:ss'),
                location_start: this.state.current_location_start,
                location_end: location,
            }))
            this.setState({
                ...this.state,
                current_date_time_end: now,
                current_location_end: location,
                setIntervalHandler: null,
                current_duration_diff: 0
            })
        }
        else {
            const setIntervalHandler = setInterval(() => {

                const dif = Math.floor((moment() - this.state.current_date_time_start) / 1000)
                const current_duration = this.hhmmss(dif)

                this.setState({
                    ...this.state,
                    current_duration,
                    current_date_time_end: '',
                    current_location_end: '',
                    current_duration_diff: dif
                    // current_units: Math.floor(dif / (60 * 15))
                })
            }, 1000)

            this.setState({
                ...this.state,
                current_date_time_start: now,
                current_location_start: location,
                setIntervalHandler
            })
        }
    }

    render() {
        const { classes } = this.props;
        const recipient = this.props.currentRecipient
        const visit = this.props.currentVisit

        let duration_saved = 0

        // visit.note_session_details_ids.forEach(element => {
        //     const start = moment(element.date_start)
        //     const end = moment(element.date_end)

        //     duration_saved += end - start
        // });
        if(visit.visit_id){
            for (const index in visit.visit_id.note_session_details_ids) {
                if (visit.visit_id.note_session_details_ids.hasOwnProperty(index)) {
                    const element = visit.visit_id.note_session_details_ids[index][0];
                    const start = moment(element.date_start)
                    const end = moment(element.date_end)
                    duration_saved += Math.floor((end - start) / 1000)
                }
            }
        }
        

        return (
            <React.Fragment>

                <Typography variant='h2'>
                    <Link className={classes.link} onClick={this.handleVisitsClick}>Visits</Link> / Visit
                </Typography>
                <Card className={classes.card}>
                    <Typography className={classes.cardTitle} color="textSecondary" gutterBottom>
                        Recipient
                        </Typography>
                    <div className={classes.cardMedia}>
                        <CardMedia
                            className={classes.cardCover}
                            component='img'
                            // image={'data:image/png;base64,' + (this.props.currentRecipient ? this.props.currentRecipient['image_small'] : '')}
                            src={'data:image/png;base64,' + (recipient ? recipient['image_small'] : '')}
                            title={recipient.name}
                        />
                        <div className={classes.cardDetails}>
                            <CardContent className={classes.cardContent}>
                                <Typography component="h5" variant="h5">
                                    {recipient.name}
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {recipient['internal_code']}
                                </Typography>
                            </CardContent>
                        </div>
                    </div>
                </Card>

                <Card className={classes.card}>
                    <Typography className={classes.cardTitle} color="textSecondary" gutterBottom>
                        Schedule
                        </Typography>
                    <div className={classes.cardDetails}>
                        <CardContent className={classes.cardContent}>
                            {/* <table className={classes.infoTable}>
                                    <tbody>
                                        <tr>
                                            <td>{visit.simple_date}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Start: <b>{visit.sb_in}</b></td>
                                            <td>{'<<Address 1>>'}</td>
                                        </tr>
                                        <tr>
                                            <td>End: <b>{visit.out}</b></td>
                                            <td>{'<<Address 2>>'}</td>
                                        </tr>
                                    </tbody>
                                </table> */}
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <b>{visit.simple_date}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    Start: <b>{visit.sb_in}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    Start Address: <b>{'<<Address 1>>'}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    End: <b>{visit.out}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    End Address: <b>{'<<Address 2>>'}</b>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </div>
                </Card>

                <Card className={classes.card}>
                    <Typography className={classes.cardTitle} color="textSecondary" gutterBottom>
                        Current
                        </Typography>
                    <div className={classes.cardDetails}>
                        <CardContent className={classes.cardContent}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={6}>
                                    Start: <b>{this.state.current_date_time_start ? this.state.current_date_time_start.format('YYYY-MM-DD HH:mm:ss') : ''}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    Location Start: <b>{this.state.current_location_start}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    End: <b>{this.state.current_date_time_end ? this.state.current_date_time_end.format('YYYY-MM-DD HH:mm:ss') : ''}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    Location End: <b>{this.state.current_location_end}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    Duration: <b>{this.hhmmss(duration_saved + this.state.current_duration_diff)}</b>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    Units: <b>{Math.floor((duration_saved + this.state.current_duration_diff) / (60 * 15))}</b>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button variant="contained" color="primary" onClick={this.handleButtonClick} disabled={this.state.isButtonDisabled}>
                                        {this.state.buttonText}
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </div>
                </Card>
            </React.Fragment>
        )
    }

    pad = (num) => {
        return ("0" + num).slice(-2);
    }
    hhmmss = (secs) => {
        var minutes = Math.floor(secs / 60);
        secs = secs % 60;
        var hours = Math.floor(minutes / 60)
        minutes = minutes % 60;
        return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
        // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
    }
}

const mapStateToProps = (state) => {
    return {
        currentVisit: state.app.global.currentVisit,
        currentRecipient: state.app.global.currentRecipient,
    }
};

export default connect(mapStateToProps, null)(withStyles(styles)(VisitPage));